import { Carousel } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';

import { ShouldRender } from '../../shared/basic/ShouldRender';
import { formateErrorObject } from '../../shared/formateErrorObject';
import { notify } from '../../shared/notify';
import {
  Book_3D,
  checkoutCardBg,
  GetFreeBook,
  LearningGoals,
  ReadingTime,
  StartingPage,
} from '../../../../assets';
import { user } from '../../../atoms/user';
import { getRewardRulesByName } from '../../../services/reward';
import { User } from '../../../utils/interfaces/User';

const cardData = [
  {
    image: GetFreeBook,
    alt: 'ReferAFriend',
    title: 'Book Genres',
    description: `Your choices help us recommend books you'll love. Don’t worry—you can update preferences anytime!`,
    buttonText: 'Refer Now',
  },
  {
    image: LearningGoals,
    alt: 'LearningGoals',
    title: 'Learning Goal',
    description:
      'Your goal helps us customize recommendations to align with your reading aspirations.',
    buttonText: 'View Rewards',
    buttonLink: '/rewards',
  },
  {
    image: ReadingTime,
    alt: 'ReadingTime',
    title: 'Reading Time',
    description:
      'This helps us suggest books that fit your schedule and make reading a consistent part of your routine.',
    buttonText: 'Check out Rewards',
    buttonLink: '/rewards',
  },
];

const OnboardingStart = () => {
  const [coins, setCoins] = useState(0);
  const userData: User | undefined = useRecoilValue(user);
  const screens = useBreakpoint();
  const handleRewardCoin = async () => {
    try {
      const data = await getRewardRulesByName('onboarding_complete');
      setCoins(data.data);
    } catch (error: any) {
      const message =
        formateErrorObject(error) || 'An error occurred while fetching data.';

      notify(message, 'error');
    }
  };
  useEffect(() => {
    handleRewardCoin();
  }, []);
  return (
    <div className='flex justify-center pb-40'>
      <div className='flex flex-col gap-y-1.5 md:gap-y-4 mt-5 md:mt-10 '>
        <span className='text-xl md:text-3xl xl:text-4xl text-start flex justify-start lg:justify-center md:text-center font-semibold text-white'>
          Hey {userData?.name},
        </span>
        <div className='flex justify-center items-center'>
          <div className='text-textLightGray text-xs flex text-start md:text-base  lg:text-center w-full lg:w-2/3'>
            Help us get to know you better so we can personalize your
            experience. This will take less than a minute.
          </div>
        </div>

        <div className='flex justify-center gap-x-3 py-4'>
          <div className='relative w-full max-w-[90vw] md:max-w-[280px] bg-[#121212] rounded-xl overflow-hidden'>
            <Carousel
              className='flex md:min-h-[300px] rounded-xl'
              dotPosition='bottom'
              autoplay
            >
              {cardData.map((card, index) => (
                <div
                  key={index}
                  className='flex flex-col items-center w-full px-5 py-6 md:p-8'
                >
                  <Image
                    src={card.image}
                    alt={card.alt}
                    width={screens.lg ? 150 : 100}
                    height={screens.lg ? 150 : 100}
                    className='rounded-lg mb-4'
                  />
                  <h3 className='text-xl font-semibold mb-2'>{card.title}</h3>
                  <p className='text-sm text-center text-textLightGray mb-4'>
                    {card.description}
                  </p>
                </div>
              ))}
            </Carousel>
          </div>
          <ShouldRender check={screens.md}>
            <div
              style={{
                boxShadow:
                  '0px 2px 0px 0.5px #FFFFFF80 inset, 0px 2px 2px 0px #0000004F',
              }}
              className='relative overflow-hidden w-full pt-[3px] px-[3px] z-10 max-w-[280px] min-h-[300px] bg-bgColor border-dropDownMenuBg border rounded-xl'
            >
              <div className='h-full'>
                <div className='relative h-40 w-full'>
                  <Image
                    src={StartingPage}
                    alt='StartingPage'
                    layout='fill'
                    objectFit='cover'
                    className='absolute top-0 rounded-t-xl'
                  />
                  <div className='absolute inset-0 flex translate-y-6 items-center justify-center'>
                    <Image
                      src={Book_3D}
                      alt='Book_3D'
                      width={screens.lg ? 150 : 100}
                      height={screens.lg ? 150 : 100}
                      style={{
                        maxHeight: '100%',
                        objectFit: 'contain',
                      }}
                    />
                  </div>
                </div>
                <div className='translate-y-9 h-full'>
                  <h3 className='text-center text-xl font-semibold text-white'>
                    Get a free book
                  </h3>
                  <div className='flex justify-center '>
                    <p className='text-center text-textLightGray w-4/5 mt-2'>
                      You will be rewarded{' '}
                      <p className='text-white font-medium inline-flex'>
                        {coins} Z-coins
                      </p>{' '}
                      when you complete onboarding.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ShouldRender>
        </div>
        <ShouldRender check={!screens.md}>
          <div>
            <div className='w-full mt-6 '>
              <div
                className='bg-cartBgColor text-white px-2 p-3 md:p-6 flex  items-center relative rounded-2xl gap-3 md:gap-6'
                style={{
                  boxShadow:
                    '1px 1px 1px 0px #FFFFFF1A inset, 0px -1px 1px 0px #FFFFFF1A inset',
                }}
              >
                <Image
                  src={checkoutCardBg}
                  alt='checkoutCardBg'
                  className='absolute right-0 z-20 h-full rounded-r-2xl w-auto '
                  style={{
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
                <ShouldRender check={screens.md}>
                  <Image
                    src={checkoutCardBg}
                    alt='checkoutCardBg'
                    className='absolute left-0 rotate-180 z-20 h-full rounded-r-2xl w-auto '
                    style={{
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                  />
                </ShouldRender>
                <div className='flex gap-x-1 items-center'>
                  <Image
                    src={Book_3D}
                    alt='Book_3D'
                    width={66}
                    height={90}
                    style={{
                      maxHeight: '100%',
                      objectFit: 'contain',
                    }}
                  />
                  <div className='flex flex-col z-20 relative md:flex-row gap-y-3 w-full  justify-between items-center'>
                    <div className='flex  justify-center flex-col  text-left '>
                      <h2 className='text-sm font-semibold mb-1'>Reward</h2>
                      <p className='text-[10px] text-textLightGray  '>
                        You will be rewarded{' '}
                        <p className='text-white font-medium inline-flex'>
                          {coins} Z-coins
                        </p>{' '}
                        when you complete onboarding.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ShouldRender>
      </div>
    </div>
  );
};

export default OnboardingStart;
